/* CurbGo PDP v3 - Estimated arrival engine (precomputed ground-transit bands, 2-digit ZIP).
 * Honest per-product estimate: handling (distributor cutoff, PT) + ground transit (ZIP distance).
 * No network, no third parties. ZIP stays in this browser (localStorage).
 * Bands precomputed from each warehouse's coordinates (MegaGoods=Valencia CA 91355, Streetwise=Winterville NC 28590).
 */
(function(){
  "use strict";
  var BANDS=[[1,1],[1,2],[2,3],[2,3],[3,4],[4,5],[4,5],[5,6]];
  var TRANSIT={ "MG":{"00":7,"01":7,"02":7,"03":7,"04":7,"05":7,"06":7,"07":7,"08":7,"10":7,"11":7,"12":7,"13":7,"14":6,"15":6,"16":6,"17":6,"18":7,"19":7,"20":6,"21":7,"22":6,"23":7,"24":6,"25":6,"26":6,"27":6,"28":6,"29":6,"30":6,"31":6,"32":6,"33":6,"34":6,"35":5,"36":5,"37":5,"38":5,"39":5,"40":5,"41":6,"42":5,"43":6,"44":6,"45":6,"46":5,"47":5,"48":6,"49":5,"50":4,"51":4,"52":5,"53":5,"54":5,"55":5,"56":4,"57":4,"58":4,"59":3,"60":5,"61":5,"62":5,"63":5,"64":4,"65":4,"66":4,"67":4,"68":4,"69":3,"70":5,"71":4,"72":4,"73":4,"74":4,"75":4,"76":4,"77":4,"78":4,"79":3,"80":3,"81":3,"82":3,"83":3,"84":2,"85":2,"86":2,"87":2,"88":3,"89":1,"90":0,"91":0,"92":0,"93":1,"94":2,"95":2,"96":2,"97":3,"98":3,"99":5}, "SW":{"00":4,"01":2,"02":2,"03":3,"04":3,"05":3,"06":2,"07":2,"08":2,"10":2,"11":2,"12":2,"13":2,"14":2,"15":2,"16":2,"17":2,"18":2,"19":2,"20":1,"21":1,"22":1,"23":1,"24":0,"25":1,"26":1,"27":0,"28":0,"29":0,"30":1,"31":1,"32":2,"33":2,"34":2,"35":2,"36":2,"37":1,"38":2,"39":2,"40":1,"41":1,"42":2,"43":2,"44":2,"45":2,"46":2,"47":2,"48":2,"49":2,"50":3,"51":3,"52":3,"53":3,"54":3,"55":3,"56":3,"57":4,"58":4,"59":5,"60":2,"61":2,"62":2,"63":2,"64":3,"65":3,"66":3,"67":3,"68":3,"69":4,"70":3,"71":3,"72":2,"73":3,"74":3,"75":3,"76":3,"77":3,"78":4,"79":4,"80":4,"81":4,"82":5,"83":6,"84":5,"85":5,"86":5,"87":4,"88":4,"89":6,"90":6,"91":6,"92":6,"93":6,"94":7,"95":6,"96":7,"97":6,"98":6,"99":7} };
  var DISTRIBUTORS={
    "MG":{ name:"MegaGoods", state:"California", cutoffPT:9, sameDayBeforeCutoff:true, transit:"MG" },
    "SW":{ name:"Streetwise", state:"North Carolina", cutoffPT:9, sameDayBeforeCutoff:true, transit:"SW" }
  };
  var DEFAULT_KEY="MG";
  var HOLIDAYS={
    "2026-01-01":1,"2026-05-25":1,"2026-07-03":1,"2026-09-07":1,"2026-11-26":1,"2026-12-25":1,
    "2027-01-01":1,"2027-05-31":1,"2027-07-05":1,"2027-09-06":1,"2027-11-25":1,"2027-12-24":1
  };
  function key(d){ return d.getUTCFullYear()+"-"+String(d.getUTCMonth()+1).padStart(2,"0")+"-"+String(d.getUTCDate()).padStart(2,"0"); }
  function isBiz(d){ var w=d.getUTCDay(); return w!==0&&w!==6&&!HOLIDAYS[key(d)]; }
  function mkDate(y,m,day){ return new Date(Date.UTC(y,m-1,day,12)); }
  function nextBiz(d){ var n=new Date(d.getTime()); do{ n.setUTCDate(n.getUTCDate()+1); }while(!isBiz(n)); return n; }
  function addBiz(d,n){ var r=new Date(d.getTime()),c=0; while(c<n){ r.setUTCDate(r.getUTCDate()+1); if(isBiz(r))c++; } return r; }
  function ptNow(){
    var f=new Intl.DateTimeFormat("en-US",{timeZone:"America/Los_Angeles",year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",hour12:false});
    var p={}; f.formatToParts(new Date()).forEach(function(x){ p[x.type]=x.value; });
    var hour=+p.hour===24?0:+p.hour;
    return { y:+p.year, m:+p.month, d:+p.day, hour:hour, minute:+p.minute };
  }
  function distFor(sku){ var pfx=(sku||"").split("-")[0].toUpperCase(); return DISTRIBUTORS[pfx]||DISTRIBUTORS[DEFAULT_KEY]; }
  function shipDate(dist){
    var pt=ptNow(), base=mkDate(pt.y,pt.m,pt.d);
    if(dist.sameDayBeforeCutoff && isBiz(base) && pt.hour<dist.cutoffPT) return { date:base, sameDay:true, pt:pt };
    return { date:nextBiz(base), sameDay:false, pt:pt };
  }
  function estimate(sku,zip){
    var dist=distFor(sku), ship=shipDate(dist);
    if(!/^\d{5}$/.test(zip||"")) return { dist:dist, ship:ship, ok:false };
    var i=TRANSIT[dist.transit][zip.slice(0,2)];
    if(i===undefined) return { dist:dist, ship:ship, ok:false, badzip:true };
    var b=BANDS[i];
    return { dist:dist, ship:ship, ok:true, arrMin:addBiz(ship.date,b[0]), arrMax:addBiz(ship.date,b[1]), band:b };
  }
  var DOW=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],MON=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  function fmt(d){ return DOW[d.getUTCDay()]+", "+MON[d.getUTCMonth()]+" "+d.getUTCDate(); }
  function fmtRange(a,b){ return key(a)===key(b)?fmt(a):fmt(a)+" to "+fmt(b); }
  function cutoffMsg(dist,ship){
    if(ship.sameDay){
      var mins=dist.cutoffPT*60-(ship.pt.hour*60+ship.pt.minute);
      var h=Math.floor(mins/60),m=mins%60;
      return "Order within "+(h>0?h+"h "+m+"m":m+"m")+" to ship today";
    }
    return "Ships the next business day";
  }
  var LS="cg_eta_zip";
  function getZip(){ try{ return localStorage.getItem(LS)||""; }catch(e){ return ""; } }
  function setZip(z){ try{ localStorage.setItem(LS,z); }catch(e){} }
  function render(root){
    var sku=root.getAttribute("data-sku")||"", zip=getZip(), e=estimate(sku,zip), msg, sub;
    if(e.ok){
      if(key(e.arrMin)===key(e.arrMax)){ msg="Arrives "+fmt(e.arrMax); sub=cutoffMsg(e.dist,e.ship)+" · to "+zip; }
      else { msg="Get it by "+fmt(e.arrMax); sub="Arrives as soon as "+fmt(e.arrMin)+" · "+cutoffMsg(e.dist,e.ship); }
    }
    else if(e.badzip){ msg="Enter a valid U.S. ZIP for a delivery date"; sub=cutoffMsg(e.dist,e.ship); }
    else { msg="Arrives in about 2 to 6 business days"; sub="Enter ZIP for exact dates · "+cutoffMsg(e.dist,e.ship); }
    document.querySelectorAll("[data-cg-eta-out]").forEach(function(o){ o.textContent=msg; });
    document.querySelectorAll("[data-cg-eta-sub]").forEach(function(s){ s.textContent=sub; });
    document.querySelectorAll(".cg-eta-zip").forEach(function(inp){ if(inp.value!==zip) inp.value=zip; });
    document.querySelectorAll("[data-cg-eta-origin]").forEach(function(o){ o.textContent=e.dist.state; });
  }
  function wire(root){
    document.querySelectorAll(".cg-eta-zip").forEach(function(inp){
      inp.addEventListener("input",function(){
        var v=inp.value.replace(/\D/g,"").slice(0,5); inp.value=v;
        if(v.length===5){ setZip(v); render(root); } else if(v.length===0){ setZip(""); render(root); }
      });
    });
    render(root); setInterval(function(){ render(root); },60000);
  }
  function enhanceBody(){
    var body=document.querySelector(".cgp-ov-body"); if(!body) return;
    var target=null;
    body.querySelectorAll("p > strong, h3, h4").forEach(function(s){ if(/^shipping$/i.test(s.textContent.trim())) target=s; });
    if(!target) return;
    var head=target.closest("p")||target, copy=head.nextElementSibling;
    var host=(copy&&copy.tagName==="P")?copy:head;
    if(host.querySelector(".cg-eta-anno")) return;
    var span=document.createElement("span");
    span.className="cgp-anno cg-eta-anno";
    span.innerHTML='<button type="button" class="cgp-anno-trg" aria-expanded="false"><b>See estimated arrival</b>'+
      '<svg class="cgp-anno-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="8" r="0.6" fill="currentColor"/></svg></button>'+
      '<span class="cgp-anno-pop" role="tooltip"><span class="cgp-anno-policy"><b data-cg-eta-out>Estimated arrival</b><br><span data-cg-eta-sub style="opacity:.85"></span></span>'+
      '<span class="cg-eta-ziprow"><input class="cg-eta-zip" type="text" inputmode="numeric" maxlength="5" placeholder="ZIP code" aria-label="ZIP code for delivery estimate"></span>'+
      '<span class="cg-eta-fine">Estimate from our <span data-cg-eta-origin>California</span> warehouse. Business days, carrier holidays excluded.</span></span>';
    host.appendChild(document.createTextNode(" ")); host.appendChild(span);
  }
  var ICONS={
    "at a glance":'<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
    "key features":'<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z"/>',
    "what's included":'<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="M3.27 6.96 12 12l8.73-5.04"/><path d="M12 22V12"/>',
    "before you buy":'<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    "perfect for":'<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/>',
    "care & use":'<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>',
    "care and use":'<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>',
    "shipping":'<path d="M1 4h14v11H1z"/><path d="M15 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2.2"/><circle cx="18" cy="18" r="2.2"/>'
  };
  function injectCSS(){
    if(document.getElementById("cg-ico-css")) return;
    var s=document.createElement("style"); s.id="cg-ico-css";
    s.textContent=".cgp-ov-body .cg-ico{display:inline-block;width:18px;height:18px;color:#A67C52;vertical-align:-3px;margin-right:8px}.cg-sec-ico{display:inline-block;vertical-align:middle;width:.8em;height:.8em;margin-right:.4em;color:#C9973A;flex:none}";
    document.head.appendChild(s);
  }
  var SEC_ICONS={
    "cgp-fits-h":'<rect x="2.5" y="8.5" width="19" height="7" rx="1.5"/><path d="M6 8.5v3.2M9.5 8.5v4M13 8.5v3.2M16.5 8.5v4"/>',
    "cgp-st-h":'<path d="M12 2.7l8.5 4.6v9.4L12 21.3 3.5 16.7V7.3z"/><path d="M3.6 7.3L12 11.9l8.4-4.6M12 11.9v9.4"/>',
    "cgp-cmp-h":'<path d="M12 4v15M8 19h8"/><path d="M6.5 5.5l-3 6a2.6 2.6 0 005.2 0l-3-6zM6.5 5.5h11"/><path d="M17.5 5.5l3 6a2.6 2.6 0 01-5.2 0l3-6z"/><circle cx="12" cy="4" r="1"/>',
    "cgp-specs-title":'<rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V3.2h6V4"/><path d="M9 9.5h6M9 13h6M9 16.5h4"/>',
    "cgp-faq-title":'<path d="M4 5h16v11H9.5L5.5 20V16H4z"/><path d="M9.4 9.2a2.6 2.6 0 113.7 2.4c-.8.4-1.1.9-1.1 1.7"/><path d="M12 15.4v.05"/>',
    "cgp-ben-h":'<path d="M12 3l2.4 5.3 5.8.6-4.3 3.9 1.2 5.7L12 21.4 6.9 18.4l1.2-5.7-4.3-3.9 5.8-.6z"/>',
    "cgp-pairs-h":'<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/>',
    "cgp-cta-h":'<path d="M3 4.5h2.2l2.3 11.2h10l2-8.2H6.3"/><circle cx="9.2" cy="19.4" r="1.3"/><circle cx="16.8" cy="19.4" r="1.3"/>'
  };
  function injectSectionIcons(){
    Object.keys(SEC_ICONS).forEach(function(cls){
      document.querySelectorAll("."+cls).forEach(function(h){
        if(h.querySelector(".cg-sec-ico")) return;
        var svg=document.createElementNS("http://www.w3.org/2000/svg","svg");
        svg.setAttribute("viewBox","0 0 24 24"); svg.setAttribute("fill","none");
        svg.setAttribute("stroke","currentColor"); svg.setAttribute("stroke-width","1.7");
        svg.setAttribute("stroke-linecap","round"); svg.setAttribute("stroke-linejoin","round");
        svg.setAttribute("class","cg-sec-ico"); svg.setAttribute("aria-hidden","true");
        svg.innerHTML=SEC_ICONS[cls]; h.insertBefore(svg,h.firstChild);
      });
    });
  }
  function injectIcons(){
    var body=document.querySelector(".cgp-ov-body"); if(!body) return;
    body.querySelectorAll("p > strong, h2, h3, h4").forEach(function(h){
      if(h.querySelector(".cg-ico")) return;
      var d=ICONS[h.textContent.trim().toLowerCase().replace(/&amp;/g,"&")]; if(!d) return;
      var svg=document.createElementNS("http://www.w3.org/2000/svg","svg");
      svg.setAttribute("viewBox","0 0 24 24"); svg.setAttribute("fill","none");
      svg.setAttribute("stroke","currentColor"); svg.setAttribute("stroke-width","1.7");
      svg.setAttribute("stroke-linecap","round"); svg.setAttribute("stroke-linejoin","round");
      svg.setAttribute("class","cg-ico"); svg.setAttribute("aria-hidden","true");
      svg.innerHTML=d; h.insertBefore(svg,h.firstChild);
    });
  }
  function init(){
    injectCSS(); injectSectionIcons();
    var root=document.getElementById("cgp-eta"); if(!root) return;
    injectIcons(); enhanceBody(); wire(root);
    document.addEventListener("click",function(ev){
      var t=ev.target.closest(".cg-eta-anno .cgp-anno-trg");
      document.querySelectorAll(".cg-eta-anno .cgp-anno-pop").forEach(function(p){
        if(t&&p===t.nextElementSibling){ p.classList.toggle("cgp-anno-open"); } else { p.classList.remove("cgp-anno-open"); }
      });
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
})();
